
@if (datePickerReady) {
  <!-- native date-/time-picker -->
  @if (!ionicPresentationIsActive) {
    <input class="input-overlay native-date-input"
      [type]="config.presentation"
      [value]="normalizedValue"
      [min]="normalizedRange.min"
      [max]="normalizedRange.max"
      [disabled]="!datePickerReady"
      (change)="onNativePickerChanged($event)"/>
  } @else {
    <div class="input-overlay" [attr.id]="id" tappable></div>
  }

  <div class="input-value-container"
    [ngClass]="{ 'has-multiple-dates': ionDatetimeConfig?.multipleDates }">
    <!-- parse single date -->
    @if (!ionDatetimeConfig?.multipleDates) {
      <ion-icon class="error-icon" name="warning" color="danger"></ion-icon>

      @if (clearButtonVisible) {
        <ion-button class="remove-button" (click)="removeDate($event)" fill="clear">
          <ion-icon name="close-circle-outline" slot="icon-only"></ion-icon>
        </ion-button>
      }

      @if (config.presentation === 'date' || config.presentation === 'time') {
        <ion-button class="date-button" [ngClass]="{ 'date-button--empty': !formattedValues[config.presentation] }">
          @if (formattedValues[config.presentation]) {
            {{formattedValues[config.presentation]}}
          } @else {
            {{ ('FORM.INPUT.' + config.presentation.toUpperCase() + '_PICKER.PLACEHOLDER') | translate }}
          }
        </ion-button>
      }
      @if (config.presentation === 'datetime-local') {
        <div class="date-time-container">
          @if (formattedValues.date) {
            <ion-button class="date-button">
              {{ formattedValues.date }}
            </ion-button>
          }
          @if (formattedValues.time) {
            <ion-button class="date-button">
              {{ formattedValues.time }}
            </ion-button>
          } @else {
            <ion-button class="date-button date-button--empty">
              {{ 'FORM.INPUT.DATE_PICKER.PLACEHOLDER' | translate }}
            </ion-button>
          }
        </div>
      }
    } @else {
      <!-- parse multiple dates (ionic presentation) -->
      @for (value of formattedMultipleDates; track value) {
        <div class="multiple-date">{{ value }}</div>
      }

      @if (!formattedMultipleDates.length) {
        <ion-button class="date-button date-button--empty">
          {{ 'FORM.INPUT.DATE_PICKER.PLACEHOLDER' | translate }}
        </ion-button>
      }
    }
  </div>

  <!--
    ionic date-/time-picker
    ion-modal is also possible, use web-date-picker-modal class then
  -->
  @if (ionicPresentationIsActive) {
    <ion-popover class="web-date-picker-popover web-date-picker-popover--{{ionDatetimeConfig.presentation}}"
      [keepContentsMounted]="true"
      [showBackdrop]="true" [trigger]="id">
      <ng-template>
        <ion-datetime class="web-date-picker"
          [showDefaultTimeLabel]="false"
          [locale]="language"
          [showDefaultButtons]="true"
          [presentation]="ionDatetimeConfig.presentation"
          [multiple]="ionDatetimeConfig.multipleDates"
          [value]="normalizedValue"
          [min]="normalizedRange.min"
          [max]="normalizedRange.max"
          [isDateEnabled]="ionDatetimeConfig.isDateEnabled"
          [showDefaultTitle]="!!ionDatetimeConfig.title"
          [cancelText]="ionDatetimeConfig.cancelText || 'BUTTON.CANCEL' | translate"
          [doneText]="ionDatetimeConfig.doneText || 'BUTTON.OK' | translate"
          (ionChange)="onIonValueConfirmed($event)">
          @if (ionDatetimeConfig.title) {
            <span slot="title">{{ ionDatetimeConfig.title }}</span>
          }
        </ion-datetime>
      </ng-template>
    </ion-popover>
  }
}
